import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useFirebase, useFirestore} from 'react-redux-firebase'
import {Table, Popup, Icon, Label, Loader, Menu, Button, Placeholder} from 'semantic-ui-react'
import * as StructureActions from '../../actions/StructureActions'
import * as moment from 'moment'

function EventSelection(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const events = useSelector((state) => (props.tournament === null || !state.structure.hasIn(['events', props.tournament['uid']])) ? null : Object.values(state.structure.getIn(['events', props.tournament['uid']]).toJS()).sort((a, b) => parseInt(a['active-to-utc'].seconds - parseInt(b['active-to-utc'].seconds))));
    const selectedEvent = useSelector((state) => {
        let selected = state.structure.getIn(['selected', 'event']);
        if(typeof selected === 'undefined' || selected === null || events === null)return null;
        
        for(var event of events)
            if(event['uid'] === selected)return event;
        return null;
    })

    useEffect(() => {
        if(props.tournament !== null)
            dispatch(StructureActions.load_events(firestore, props.tournament['uid']));
    }, [props.tournament === null, events === null])

    return (
        (events === null)?
            <Loader inline active />
        :
            <div>
                <h4 style={{
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    textAlign: 'center'
                }}>{props.tournament.name}</h4>
                <Menu vertical fluid>
                {
                    Object.values(events).map((event) => {
                        return <Menu.Item active={selectedEvent !== null && selectedEvent.uid === event.uid} onClick={(e) => {
                            dispatch(StructureActions.select_event(event['uid']))
                        }}>
                            <div style={{
                                fontSize: '80%',
                                color: '#999999',
                                marginBottom: '3px'
                            }}>{moment(event['active-to-utc'].toDate()).format('DD.MM.YYYY, HH:mm [Uhr]')}</div>
                            {event.name}
                        </Menu.Item>
                    })
                }
                </Menu>
            </div>
    )
}

function TournamentSelection(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const tournaments = useSelector((state) => (props.category === null || !state.structure.hasIn(['tournaments', props.category['category-in-sport-uid']])) ? null : Object.values(state.structure.getIn(['tournaments', props.category['category-in-sport-uid']]).toJS()).sort((a, b) => parseInt(a['kisad-id'] - parseInt(b['kisad-id']))));
    const selectedTournament = useSelector((state) => {
        let selected = state.structure.getIn(['selected', 'tournament']);
        if(typeof selected === 'undefined' || selected === null || tournaments === null)return null;
        
        for(var tournament of tournaments)
            if(tournament['uid'] === selected)return tournament;
        return null;
    })

    useEffect(() => {
        if(props.category !== null)
            dispatch(StructureActions.load_tournaments(firestore, props.category['category-in-sport-uid']));
    }, [props.category === null, tournaments === null])

    return (
        (tournaments === null)?
            <Loader inline active />
        :
            (selectedTournament === null)?
            <div>
                <h4 style={{
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    textAlign: 'center'
                }}>{props.category.name}</h4>
                <Menu vertical fluid>
                {
                    Object.values(tournaments).map((tournament) => {
                        return <Menu.Item onClick={(e) => {
                            dispatch(StructureActions.select_tournament(tournament['uid']))
                        }}>
                            {tournament.name}
                            <Label color={tournament['event-count'].active?'green':'grey'}>{tournament['event-count'].active}</Label>
                        </Menu.Item>
                    })
                }
                </Menu>
            </div>
            :
                <div>
                    <Button fluid onClick={(e) => {
                        dispatch(StructureActions.select_tournament(null));
                    }}>{props.category.name}</Button>
                    <EventSelection tournament={selectedTournament} />
                </div>
    )
}

function CategorySelection(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const categories = useSelector((state) => (props.sport === null || !state.structure.hasIn(['categories', props.sport.uid])) ? null : Object.values(state.structure.getIn(['categories', props.sport.uid]).toJS()).sort((a, b) => parseInt(a['kisad-id'] - parseInt(b['kisad-id']))));
    const selectedCategory = useSelector((state) => {
        let selected = state.structure.getIn(['selected', 'cis']);
        if(typeof selected === 'undefined' || selected === null || categories === null)return null;
        
        for(var category of categories)
            if(category['category-in-sport-uid'] === selected)return category;
        return null;
    })

    useEffect(() => {
        if(props.sport !== null)
            dispatch(StructureActions.load_categories(firestore, props.sport.uid));
    }, [props.sport === null, categories === null])

    return (
        (categories === null)?
            <Loader inline active />
        :
            (selectedCategory === null)?
            <div>
                <h4 style={{
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    textAlign: 'center'
                }}>{props.sport.name}</h4>
                <Menu vertical fluid>
                {
                    Object.values(categories).map((category) => {
                        return <Menu.Item onClick={(e) => {
                            dispatch(StructureActions.select_category(category['category-in-sport-uid']))
                        }}>
                            {category.name}<Label color={category['event-count'].active?'green':'grey'}>{category['event-count'].active}</Label>
                        </Menu.Item>
                    })
                }
                </Menu>
            </div>
            :
                <div>
                    <Button fluid onClick={(e) => {
                        dispatch(StructureActions.select_category(null));
                    }}>{props.sport.name}</Button>
                    <TournamentSelection category={selectedCategory} />
                </div>
    )
}

export function Selection(props) {
    const firebase = useFirebase()
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const sports = useSelector((state) => state.structure.get('sports') === null ? null : Object.values(state.structure.get('sports').toJS()).sort((a, b) => parseInt(a['kisad-id'] - parseInt(b['kisad-id']))));
    const selectedSport = useSelector((state) => {
        let selected = state.structure.getIn(['selected', 'sport']);
        if(typeof selected === 'undefined' || selected === null)return null;
        
        for(var sport of sports)
            if(sport.uid === selected)return sport;
        return null;
    })

    useEffect(() => {
        dispatch(StructureActions.load_sports(firestore));
    }, [sports === null])

    return (
        <div style={{
            overflow: 'auto',
            height: '100%'
        }}>
        {
            (sports === null)?
                <Loader inline active />
            :
                (selectedSport === null)?
                <Menu vertical fluid>
                {
                    Object.values(sports).map((sport) => {
                        return <Menu.Item onClick={(e) => {
                            dispatch(StructureActions.select_sport(sport.uid))
                        }}>
                            {sport.name}
                            <Label color={sport['event-count'].active?'green':'grey'}>{sport['event-count'].active}</Label>
                        </Menu.Item>
                    })
                }
                </Menu>
                :
                    <div>
                        <Button fluid onClick={(e) => {
                            dispatch(StructureActions.select_sport(null));
                        }}>Alle Sportarten</Button>

                        <CategorySelection sport={selectedSport} />
                    </div>
        }
        </div>
    )
}